import { getValue, darken } from "../utils.js";

export const SLIDER = {
  "Slider.Handle.Border.Color": {
    ref: "Color.Secondary.Two.500"
  },
  "Slider.Bar.Color": {
    ref: "Color.Gray.400"
  },
  "Slider.Bar.Selected.Color": {
    ref: "Color.Secondary.Two.500"
  },
  "Slider.Bar.Selected.Hover.Color": {
    ref: "Color.Secondary.Two.500"
  },
  "Slider.Handle.Bg.Color": {
    ref: "Color.Bg.white"
  },
  "Slider.Handle.Hover.Border.Color": {
    ref: "Color.Secondary.Two.600"
  },
  "Slider.Handle.Focus.Border.Color": {
    valueFunc: (meta) => {
      return darken(getValue("Slider.Handle.Border.Color", meta), 0.2);
    }
  },
  "Slider.Bar.Readonly.Color": {
    valueFunc: (meta) => {
      return darken(getValue("Slider.Bar.Color", meta), 0.3);
    }
  }
};
